































































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

@Component({
  methods: {
    ...mapActions([
      'setLoggedIn',
      'setUserDetails',
      'showSuccessToast',
      'showErrorToast',
      'setUserType',
      'setupAppData',
      '',
    ]),
    ...mapGetters(['userDetails']),
  },
  computed: {...mapGetters(['isLoggedIn'])},
})
export default class AdminLogin extends Vue {
  //Store variables
  showSuccessToast: any;
  showErrorToast: any;
  setLoggedIn: any;
  isLoggedIn?: boolean;
  setUserDetails: any;
  userDetails: any;
  setUserType: any;
  setupAppData: any;

  //Form variables
  email = '';
  password = '';
  showPass = false;
  showLoginForm = true;
  recoveryEmail = '';
  title = 'Structural Condition Monitoring Software';
  formHeader = 'Login Form';
  isLoginBtnDisable = true;

  //Form validation variables
  onNullValidationMsg = 'This field is required';
  emailValidationMsg: any = null;
  passwordValidationMsg: any = null;
  recoveryEmailValidationMsg: any = null;

  //loader variable
  loadingBtnStatus = false;

  validateEmail() {
    if (this.email === '' || this.email === null) {
      this.emailValidationMsg = this.onNullValidationMsg;
      this.isLoginBtnDisable = true;
      return false;
    }
    // else if (!Utils.validateEmail(this.email)) {
    //   this.emailValidationMsg = 'E-mail is not valid.';
    //   this.isLoginBtnDisable = true;
    //   return false;
    // }
    else if (this.password.length > 0) {
      this.emailValidationMsg = '';

      this.isLoginBtnDisable = false;
    } else {
      this.emailValidationMsg = '';

      return true;
    }
  }

  validatePassword() {
    if (this.password.length < 1 || this.password === '') {
      this.isLoginBtnDisable = true;
      this.passwordValidationMsg = this.onNullValidationMsg;
      return false;
    } else if (Utils.validateEmail(this.email)) {
      this.isLoginBtnDisable = false;
      this.passwordValidationMsg = '';
      return true;
    }
  }

  validateLoginForm() {
    return this.validateEmail && this.validatePassword;
  }

  //login button handler
  public async _loginHandler() {
    if (!this.validateLoginForm()) return false;

    this.loadingBtnStatus = true;
    try {
      let response = await API.getLoginAuthentication(this.email, this.password);
      this.loadingBtnStatus = false;
      if (response.status === 200 && response.data.data) {
        const data = response.data.data;
        sessionStorage.setItem('user', JSON.stringify(data));
        this.setLoggedIn(true);
        this.setupAppData();
        this.setUserDetails({
          data: data,
          lastActiveShip: data.lastActiveShip,
        });
        if (data.internal[0]) {
          let userType = data.internal[0].group.groupName.trim();
          this.setUserDetails({
            type: {
              roleId: data.internal[0].group.groupId,
              name: userType,
            },
          });
        }

        if (data.authorities) {
          let permissions = data?.authorities?.groupAuthorities;

          this.setUserDetails({
            permissions: permissions,
          });
        }

        // this.setUserDetails(data);
        // if (data.internal[0]) {
        //   let userType = data.internal[0].group.groupName;
        //   this.setUserType(userType);
        // }

        //

        this._formReset();
        this.$router.replace('/');
      } else {
        let error: string;
        error = response.data.error;
        if (error.includes('invalid_grant')) {
          error = 'Please enter valid e-mail and password.';
        } else if (error.includes('unauthorized')) {
          error = 'No account found for this email.';
        } else if (error.includes('user is disabled')) {
          error = 'You are not authenticated.';
        }
        this.showErrorToast({msg: error});
        this._formReset();
        return;
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  validateRecoveryEmail() {
    if (this.recoveryEmail === '' || this.recoveryEmail === null) {
      this.recoveryEmailValidationMsg = this.onNullValidationMsg;
      return false;
    } else if (!Utils.validateEmail(this.recoveryEmail)) {
      this.recoveryEmailValidationMsg = 'E-mail is not valid.';
      return false;
    } else {
      this.recoveryEmailValidationMsg = null;
      return true;
    }
  }

  //forgot password button handler
  async _submitHandler() {
    if (!this.validateRecoveryEmail()) return false;
    else {
      try {
        this.loadingBtnStatus = true;
        let apiResponse = await API.forgotPassword(this.recoveryEmail);
        this.loadingBtnStatus = false;
        if (apiResponse.message) {
          this.showSuccessToast({msg: apiResponse.message});
          setTimeout(() => this.changeForm(), 4000);
        } else {
          this.showErrorToast({msg: apiResponse.error});
          return this._formReset();
        }
      } catch (error) {
        this.loadingBtnStatus = false;
        this.showErrorToast({msg: 'Network error'});
      }
    }
  }

  //toggle password visibility
  togglePassword() {
    this.showPass = !this.showPass;
  }

  //swap login and forgot password form
  changeForm() {
    this._formReset();
    this.showLoginForm = !this.showLoginForm;
    this.showLoginForm ? (this.formHeader = 'Login Form') : (this.formHeader = 'Forgot Password');
  }

  //reset form
  _formReset() {
    this.email = '';
    this.password = '';
    this.recoveryEmail = '';
    this.emailValidationMsg = null;
    this.passwordValidationMsg = null;
    this.recoveryEmailValidationMsg = null;
  }
}
